var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
let LandingScope = class LandingScope extends Scope {
    constructor() {
        // :: o heroi
        super(...arguments);
        this.headline = '';
        this.subheadline = '';
        /** A frase que resume a oferta, logo abaixo do heroi. */
        this.promise = '';
        // :: o corpo
        this.metricsTitle = '';
        this.metrics = [];
        this.stepsTitle = '';
        this.stepsSubtitle = '';
        this.steps = [];
        this.features = [];
        this.voicesTitle = '';
        this.voices = [];
        // :: o fecho
        this.closingTitle = '';
        this.closingText = '';
        // :: as duas portas
        /** O rotulo de cada acao fica aqui porque e copia, como o resto. */
        this.signInLabel = '';
        /**
         * O rotulo do contato comercial, no lugar do antigo "Criar conta".
         *
         * Nao ha autoatendimento: quem administra empresas e o administrador geral, e
         * quem cadastra profissional e o administrador da empresa. A pagina VENDE, entao
         * o que ela oferece a quem se interessou e falar com alguem.
         */
        this.contactLabel = '';
        /**
         * Para onde o contato vai. **Vazio enquanto o cliente nao informar**, e enquanto
         * estiver vazio o botao NAO aparece - melhor uma chamada a menos que um botao
         * que nao leva a lugar nenhum.
         */
        this.contactEmail = '';
        this.onSignIn = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "headline", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "subheadline", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "promise", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "metricsTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], LandingScope.prototype, "metrics", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "stepsTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "stepsSubtitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], LandingScope.prototype, "steps", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], LandingScope.prototype, "features", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "voicesTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], LandingScope.prototype, "voices", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "closingTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "closingText", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "signInLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "contactLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], LandingScope.prototype, "contactEmail", void 0);
LandingScope = __decorate([
    Observable
], LandingScope);
export { LandingScope };
//# sourceMappingURL=landing.scope.js.map